import declare from "dojo/_base/declare";
import New from "csi/table/New";

const NewProductHierarchy = declare(New, {

	/** @property {string} productType - type of product shown in view */
	productType: "",

	/**
	* @override
	* Pass productType to form
	*/
	onCreatePopupParams(params) {
		params.productType = this.productType;
	},
});

export = NewProductHierarchy;
